import React from 'react'
import { Form } from '_zari/core'

const FlagBolsaFormGroup = ({ value, onChange }) => {
  return (
    <Form.Checkbox
      checked={value}
      onChange={onChange}
      id='checkbox-flagSeleccionarTodo-resumenBajas'
      label='Seleccionar Todos'
    />
  )
}

export default FlagBolsaFormGroup
